import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import ConfirmPaymentSmartHm from "../../sections/SmartHome/ConfirmPayment";

const ConfirmPaymentSmartHomes = () => {
  return (
    <Layout> 
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader
        pageTitle="Smart Home Services"
        routeName="Smart Home Services"
      />
      <ConfirmPaymentSmartHm />
    </Layout>
  );
};

export default ConfirmPaymentSmartHomes;